import React from 'react';

const MoviesAdminAccessSection = ({ onOpen, isEnabled = true }) => {
  return (
    <section aria-labelledby="movies-admin-access-title" className="mb-20">
      <div className="overflow-hidden rounded-lg bg-[#0A1828] p-8 text-white shadow-lg">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-[#FFD6A6]">
            Area administrativa
          </p>
          <h2 id="movies-admin-access-title" className="mt-3 text-3xl font-bold">
            Configuracoes do site
          </h2>
          <p className="mt-4 text-[#FFF0BE]">
            A area administrativa agora fica em uma tela separada. Ao clicar no botao abaixo, voce
            informa a credencial e entra no painel com o formulario de publicacao.
          </p>
        </div>

        {isEnabled ? (
          <div className="mt-8">
            <button
              type="button"
              onClick={onOpen}
              className="inline-flex items-center rounded-md bg-gradient-to-r from-[#FF9A86] via-[#FFB399] to-[#FFD6A6] px-5 py-2.5 text-sm font-semibold text-[#0A1828] transition hover:brightness-105"
            >
              Acessar area administrativa
            </button>
          </div>
        ) : (
          <p className="mt-8 text-sm text-[#FFF0BE]">
            A area administrativa fica disponivel apenas no deploy principal (Vercel same-origin).
          </p>
        )}
      </div>
    </section>
  );
};

export default MoviesAdminAccessSection;
